import { Component, OnInit, Input , AfterContentChecked} from '@angular/core';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';

@Component({
  selector: 'app-helpbutton-staffs-card',
  templateUrl: './helpbutton-staffs-card.component.html',
  styleUrls: ['./helpbutton-staffs-card.component.scss']
})
export class HelpbuttonStaffsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enabledCount: any;
  disabledCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('staffs-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('staffs-counts-spinner');
      this.showCounter = true;
      this.enabledCount = this.data.availableStaffs;
      this.disabledCount = this.data.unavailableStaffs;
    } else if ('-' === this.data) {
      this.enabledCount = '-';
      this.disabledCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('staffs-counts-spinner');
    }
  }

}
